import { SvgIcon } from '@material-ui/core';
import { SvgIconProps } from '@material-ui/core/SvgIcon';
import React, { FC } from 'react';

import { IconTypes } from 'src/types';

export type CheckedProps = SvgIconProps;

/**
 * @description This icon is primarily for use as the icon to render when a checkbox is checked
 */
export const Checked: FC<CheckedProps> = props => (
  <SvgIcon aria-label={IconTypes.CHECKBOX_CHECKED} viewBox="0 0 16 16" {...props}>
    <path d="M5 8L7 10L11 6" stroke="white" strokeLinecap="square" strokeWidth="1.5" />
  </SvgIcon>
);
